import React, { useContext } from "react";
import {
  Box,
  Heading,
  FormControl,
  FormLabel,
  Input,
  SimpleGrid,
  Text,
  VStack,
  Divider
} from "@chakra-ui/react";
import { Pie } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend
} from "chart.js";

import GanttChart from "./GanttChart";
import axios from "axios";
import { useState } from "react";
import AuthContext from "../../contexts/AuthContext";

ChartJS.register(ArcElement, Tooltip, Legend);

// Dummy data - replace with real data as needed
const financials = {
  fatturatoTotale: 50000,
  fatturatoResiduo: 20000
};

const expenseCategories = {
  labels: ["Materiali", "Manodopera", "Trasporti", "Altro"],
  datasets: [
    {
      data: [20000, 15000, 10000, 5000],
      backgroundColor: ["#3182ce", "#63b3ed", "#90cdf4", "#bee3f8"]
    }
  ]
};

const CommessaPage = ({commessa_id}) => {
  const [commessa, setCommessa] = useState(null);
  const [expenseCategories, setExpenseCategories] = useState(null);
  const {getToken} = useContext(AuthContext);

  function getCommessaData() {
    axios.get('/api/commesse/' + commessa_id, {
      headers: {
          Authorization: `Bearer ${getToken()}`,
      },
    }).then(response => {
      if (response.status === 200) {
        setCommessa(response.data);
      } else {
        console.error("Error fetching commessa: " + response.data);
      }
    }).catch((error) => {
      console.error("Error fetching commessa");
    });
  }

  function computeExpenseCategories() {
    const categories = [];

    commessa.expenses.forEach(expense => {
      const category = categories.find(cat => cat.name === expense.category);
      if (category) {
        category.amount += expense.amount;
      } else {
        categories.push({ name: expense.category, amount: expense.amount });
      }
    });
  }

  return (
    <>
      <SimpleGrid columns={[1, null, 2]} spacing={10} mb={6}>
        {/* Financial summary fields */}
        <VStack align="start" spacing={4}>
          <FormControl>
            <FormLabel>Fatturato Totale</FormLabel>
            <Input
              value={commessa.total_amount}
              isReadOnly
              variant="filled"
            />
          </FormControl>

          <FormControl>
            <FormLabel>Fatturato Residuo</FormLabel>
            <Input
              value={commessa.to_be_invoiced}
              isReadOnly
              variant="filled"
            />
          </FormControl>
        </VStack>

        {/* Pie chart for project expenses */}
        <Box>
          <Text mb={2} fontWeight="medium">
            Spese per Categoria
          </Text>
          <Box maxW="300px" maxH="300px" mx="auto">
            <Pie data={expenseCategories} />
          </Box>
          
        </Box>
      </SimpleGrid>

      <Divider my={6} />

      {/* Gantt Chart component usage */}
      <Heading size="md" mb={2}>
        Diagramma Gantt
      </Heading>
      {/* <GanttChart events={events} /> */}
      </>
  );
};

export default CommessaPage;
